<template>
  <div class="item-container"><slot></slot></div>
</template>

<script>
export default {
  name: 'item-container'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.item-container {
  + .item-container {
    margin-top: 25px;
  }
  .heading-label{
    margin-bottom: 10px;
  }
  .contents-text {
    + .form-select {
      margin-top: 10px;
    }
    + .form-select + .form-select {
      margin-top: 10px;
    }
    + .form-file {
      margin-top: 10px;
    }
    + .form-input {
      margin-top: 10px;
    }
    + .contents-text {
      margin-top: 10px;
    }
  }
  .form-input + .contents-text {
    margin-top: 15px;
  }
  .form-select {
    + .form-select {
      margin-left: 10px;
    }
    + .contents-text {
      margin-top: 15px;
    }
  }
  .form-checkbox + .form-textfield {
    margin-top: 10px;
  }
  .error-message {
    margin-top: 10px;
    margin-bottom: 20px;
    + .contents-text {
      margin-top: 10px;
    }
    + .error-message {
      margin-top: -10px;
    }
  }
}
</style>
